import logo from "Assets/Image/Common/logo.png";
import ethicalIcon from "Assets/Image/commitment/EthicalStandards.png";
import customIcon from "Assets/Image/commitment/ValueBasedSolutions.png";
import gradingIcon from "Assets/Icons/grading.svg";
import perfectIcon from "Assets/Image/News/perfect.png";
import fancyShapeIcon from "Assets/Image/News/fancy-shape.png";
import consistency from "Assets/Image/News/consistency.png";
import layoutsIcon from "Assets/Image/Application/NECK.png";
import jgtddubai from "Assets/Image/News/Grid/jgtd-dubai.jpg";
// import jewelleryarabia from "Assets/Image/News/Grid/jewellery-arabia.jpg";
import jmahongkong from "Assets/Image/News/Grid/jma.jpg";
import news1 from "Assets/Image/News/geneve-post.png";
import news2 from "Assets/Image/News/jck-post.png";
import news3 from "Assets/Image/News/Grid/hk-world.jpg";
import news4 from "Assets/Image/News/iijs.png";
import news5 from "Assets/Image/News/Grid/vicenza.jpg";
import hktdc from "Assets/Image/News/Grid/hktdc.jpg";
import miami from "Assets/Image/News/Grid/miami.jpg";
export const newsPosts = {
    // 1: {
    //     id: 1,
    //     title: "Jewellery Arabia - The Most Prestigious Luxury Shopping Event",
    //     publishTitle: "Arjiv Exports at Jewellery Arabia",
    //     image: jma,
    //     alt: "Jewellery Arabia",
    //     subtitle: "Join us to explore our exquisite range of natural, ethically sourced diamonds",
    //     slug: "jewellery-arabia",
    //     metaDescription: "Arjiv Exports is proud to participate in Jewellery Arabia 2025, premier luxury jewellery exhibition.",
    //     content: `
    //     <div class="news-article">
    //         <!-- Main Content -->
    //         <div class="content-wrapper max-w-3xl mx-auto px-4">
    //             <!-- Introduction -->
    //             <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
    //                 <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
    //                     <div>
    //                         <div class="font-bold text-gray-700 mb-1 flex items-center">
    //                             <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    //                             </svg>
    //                             Event Date: <span class="font-normal ml-2">November 25–29, 2025</span>
    //                         </div>
    //                         <div class="font-bold text-gray-700 mb-1 flex items-center">
    //                             <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    //                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    //                             </svg>
    //                             Venue: <span class="font-normal ml-2">Exhibition World Bahrain</span>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 <div class="prose max-w-none">
    //                     <p class="text-lg text-justify leading-relaxed mb-4"><span class="font-semibold text-black-800">Arjiv Exports</span> is proud to participate in <span class="font-semibold text-black-800">Jewellery Arabia 2025,</span> premier luxury jewellery exhibition. Held at the <span class="font-semibold text-black-800">Exhibition World Bahrain,</span> this prestigious event attracts global jewellery houses, luxury buyers, designers, and trade professionals from across the Middle East and beyond.</p>
                        
    //                     <p class="text-lg text-justify leading-relaxed mb-6">With a legacy since <span class="font-semibold text-black-800">1985,</span> Arjiv Exports brings to Bahrain its signature selection of <span class="font-semibold text-black-800">natural fancy shape diamonds, precision-cut layouts, and ethically sourced</span> stones crafted with passion, precision, and trust.</p>

    //                     <p class="text-lg text-justify leading-relaxed mb-6">Whether you are a <span class="font-semibold text-black-800">trade professional, luxury buyer, diamond buyer, jewelry manufacturer, designer, or trader,</span> stop by at <span class="font-semibold text-black-800">Jewellery Arabia</span> and experience our craftsmanship up close.</p>
    //                 </div>
    //             </div>

    //             <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About Jewellery Arabia</h2>
    //             <p class="mb-6 text-justify">For more than three decades, <span class="font-semibold text-black-800">Jewellery Arabia</span> has been the Middle East’s most prestigious luxury jewellery and watch exhibition. Featuring international brands, emerging designers, and leading manufacturers, it is the ultimate destination for trade professionals and luxury buyers in the GCC.</p>
            
    //             <h2 class="text-2xl font-serif mt-8 mb-4">Who We Are</h2>
    //             <p class="mb-4"><b>Arjiv Exports</b> is an <b>RJC Certified Diamond Manufacturer</b> known for:</p>
    //             <ul class="list-none mb-6">
    //                 <li class="mb-2">✦ 100% natural, conflict-free rough and polished diamonds</li>
    //                 <li class="mb-2">✦ Unique and rare diamond shapes, calibrated to precision</li>
    //                 <li class="mb-2">✦ Tailor-made sourcing for global jewellery brands</li>
    //                 <li class="mb-2">✦ Guaranteed quality, consistency, and timely global shipping</li>
    //                 <li class="mb-2">✦ Ethical and traceable supply chain practices</li>
    //                 <li class="mb-2">Visit <a href="/our-history" class="text-blue-700 hover:underline"><b>our history</b></a> page to learn more about us.</li>
    //             </ul>

    //             <!-- What You'll See at Our Booth - Enhanced Version -->
    //             <div class="mt-12">
    //                 <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
    //                 <p class="mb-8 text-justify text-gray-700 max-w-2xl">At <b>Jewellery Arabia 2025</b>, we’ll be presenting a refined and diverse range of diamonds, including:</p>
                    
    //                 <div class="grid md:grid-cols-2 gap-6">
    //                     <!-- Column 1 -->
    //                     <div class="space-y-6">
    //                         <div class="flex items-start">
    //                              <div class="p-2 mr-4 flex-shrink-0">
    //                                 <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
    //                             </div>
    //                             <div>
    //                                 <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Exclusive Fancy Shape Diamonds</h3>
    //                                 <p class="text-stone-700 text-sm leading-relaxed">Explore a wide range of unique and creative diamond cuts from traditional fancy shapes and rare shapes designed.</p>
    //                             </div>
    //                         </div>

    //                         <div class="flex items-start">
    //                             <div class="p-2 mr-4 flex-shrink-0">
    //                                 <img src="${layoutsIcon}" alt="Logo" class="w-12" />
    //                             </div>
    //                             <div>
    //                                 <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Brilliant Melee Diamonds</h3>
    //                                 <p class="text-stone-700 text-sm leading-relaxed">Bright, consistent, and precisely cut melee diamonds in different sizes, ideal for pavé settings, halos, and detailed craftsmanship.</p>
    //                             </div>
    //                         </div>

    //                         <div class="flex items-start">
    //                             <div class="p-2 mr-4 flex-shrink-0">
    //                                 <img src="${customIcon}" alt="Logo" class="w-12" />
    //                             </div>
    //                             <div>
    //                                 <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Tailored Solutions for Brands & Designers</h3>
    //                                 <p class="text-stone-700 text-sm leading-relaxed">Tell us what you’re creating — we’ll help you find the perfect stones.</p>
    //                             </div>
    //                         </div>
    //                     </div>

    //                     <!-- Column 2 -->
    //                     <div class="space-y-6">

    //                         <div class="flex items-start">
    //                             <div class="p-2 mr-4 flex-shrink-0">
    //                                 <img src="${perfectIcon}" alt="Logo" class="w-12" />
    //                             </div>
    //                             <div>
    //                                 <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Matched Diamond Layouts</h3>
    //                                 <p class="text-stone-700 text-sm leading-relaxed">Perfectly calibrated diamonds arranged in matched sets for necklaces, earrings, and bracelets.</p>
    //                             </div>
    //                         </div>

    //                         <div class="flex items-start">
    //                             <div class="p-2 mr-4 flex-shrink-0">
    //                                 <img src="${ethicalIcon}" alt="Logo" class="w-12" />
    //                             </div>
    //                             <div>
    //                                 <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced Diamonds in All Calibers</h3>
    //                                 <p class="text-stone-700 text-sm leading-relaxed">Every stone comes with a promise of responsibility, traceability, and authenticity, giving brands and buyers full confidence in their sourcing.</p>
    //                             </div>
    //                         </div>

    //                         <div class="flex items-start">
    //                             <div class="p-2 mr-4 flex-shrink-0">
    //                                 <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
    //                             </div>
    //                             <div>
    //                                 <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Customer's Focused Sourcing Solutions</h3>
    //                                 <p class="text-stone-700 text-sm leading-relaxed">Whether you’re a jewellery house or an independent designer, we help you find the right stones for your vision, from rare custom cuts to consistent supply.</p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
                    
    //             <div class="mt-4 p-4">
    //                 <p class="text-lg text-gray-700 italic">Whether you're looking for a trusted sourcing partner or a unique piece for your next jewellery collection, we're here to collaborate and support your brand's growth.</p>
    //             </div>
    //             <!-- Why Visit -->
    //             <section class="mb-12 mt-6">
    //                 <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
    //                     <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
    //                     Why Visit Us at Jewellery Arabia?
    //                 </h2>
                    
    //                 <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
    //                     <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
    //                         <div class="flex items-start">
    //                             <div class="flex-shrink-0 mr-4">
    //                                 <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
    //                                     <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //                                         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    //                                     </svg>
    //                                 </div>
    //                             </div>
    //                             <div>
    //                                 <h3 class="text-xl font-bold text-gray-800 mb-2">Meet Our Diamond Specialists</h3>
    //                                 <p class="text-gray-700">Meet our founders and specialists in person to discuss your sourcing needs and get professional insights personalized to your market.</p>
    //                             </div>
    //                         </div>
    //                     </div>
                        
    //                     <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
    //                         <div class="flex items-start">
    //                             <div class="flex-shrink-0 mr-4">
    //                                 <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
    //                                     <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //                                         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    //                                         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    //                                     </svg>
    //                                 </div>
    //                             </div>
    //                             <div>
    //                                 <h3 class="text-xl font-bold text-gray-800 mb-2">Experience Quality Firsthand</h3>
    //                                 <p class="text-gray-700">Photographs and online catalogs can’t capture the true brilliance of a diamond. At our booth, you’ll be able to examine cut, clarity, and sparkle up close..</p>
    //                             </div>
    //                         </div>
    //                     </div>
                        
    //                     <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
    //                         <div class="flex items-start">
    //                             <div class="flex-shrink-0 mr-4">
    //                                 <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
    //                                     <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //                                         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    //                                     </svg>
    //                                 </div>
    //                             </div>
    //                             <div>
    //                                 <h3 class="text-xl font-bold text-gray-800 mb-2">Build Long-Term Relationships</h3>
    //                                 <p class="text-gray-700">We’re not just exhibitors; we’re partners. With decades of industry experience, we focus on creating sustainable, long-term collaborations with our clients worldwide.</p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </section>

    //             <!-- Call to Action -->
    //             <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
    //                 <p class="text-2xl font-serif font-bold mb-4">Let's Connect in Bahrain</p>
    //                 <p class="mb-4">We'd love to meet you at the show!</p>
    //                 <p class="mb-2"><span class="font-bold">Date:</span> November 25–29, 2025</p>
    //                 <p class="mb-2"><span class="font-bold">Place:</span> Exhibition World Bahrain</p>
    //                 <p class="mb-2 mt-6">
    //                     <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
    //                         harshil@arjiv.com
    //                     </a>
    //                     <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
    //                         +91-9313807684
    //                     </a>
    //                 </p>
    //             </div>
    //         </div>
    //     </div>
    //     `
    // },
    1: {
        id: 2,
        title: "JMA | Hong Kong International Jewellery Show",
        publishTitle: "Arjiv Exports at JMA Hong Kong",
        image: jmahongkong,
        alt: "JMA Hong Kong International Jewellery Show",
        subtitle: "Join us at Booth 1DA29 to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "jma-hong-kong",
        metaDescription: "At Arjiv Exports, we're excited to showcase our diamond expertise at JMA Hong Kong International Jewellery Show, a premier platform where jewellery, gemstones, and innovation converge.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">November 27–30, 2025</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">Hong Kong Convention and Exhibition Centre</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth No. 1DA29
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4">At Arjiv Exports, we're thrilled to be part of the <span class="font-semibold text-black-800">JMA | Hong Kong International Jewellery Show</span>, one of Asia's premier jewellery trade events. This prestigious show brings together global exhibitors and trade buyers, showcasing the finest in jewellery, gemstones, and innovation.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">We're excited to showcase our diamond expertise in <span class="font-semibold text-black-800">natural fancy shape diamonds, precision-cut layouts, and ethically sourced stones</span> crafted with passion, precision, and trust.</p>

                        <p class="text-lg text-justify leading-relaxed mb-6">Whether you are a <span class="font-semibold text-black-800">trade professional, luxury buyer, diamond buyer, or jewelry manufacturer,</span> stop by at JMA Hong Kong and experience our craftsmanship up close.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About JMA Hong Kong International Jewellery Show</h2>
                <p class="mb-6 text-justify">The <span class="font-semibold text-black-800">JMA | Hong Kong International Jewellery Show</span> is one of Asia's most influential B2B jewellery trade events, held at the iconic Hong Kong Convention and Exhibition Centre. It connects global exhibitors with trade buyers from key markets, offers a curated exhibition of finished jewellery, gemstones, and related innovations, and aims to boost industry collaboration across regions.</p>
            
                <h2 class="text-2xl font-serif mt-8 mb-4">Who We Are</h2>
                <p class="mb-4"><b>Arjiv Exports</b> is an <b>RJC Certified Diamond Manufacturer</b> known for:</p>
                <ul class="list-none mb-6">
                    <li class="mb-2">✦ 100% natural, conflict-free rough and polished diamonds</li>
                    <li class="mb-2">✦ Unique and rare diamond shapes, calibrated to precision</li>
                    <li class="mb-2">✦ Tailor-made sourcing for global jewellery brands</li>
                    <li class="mb-2">✦ Guaranteed quality, consistency, and timely global shipping</li>
                    <li class="mb-2">✦ Ethical and traceable supply chain practices</li>
                    <li class="mb-2">Visit <a href="/our-history" class="text-blue-700 hover:underline"><b>our history</b></a> page to learn more about us.</li>
                </ul>

                <!-- What You'll See at Our Booth - Enhanced Version -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At <b>JMA Hong Kong 2025</b>, we'll be presenting a refined and diverse range of diamonds, including:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Exclusive Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">From classic cuts to rare silhouettes, we'll display a diverse selection of shapes crafted with precision and flair.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Brilliant Polished Melee Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Ideal for pavé, halos, and accent detailing, consistent, high-quality small stones.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Tailored Solutions for Brands & Designers</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Tell us what you're creating — we'll help you find the perfect stones.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Matched Diamond Layouts</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Sets of diamonds sized and quality–matched for jewellery manufacturers, ready for seamless incorporation into high-end designs.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Our commitment to traceability and responsible sourcing ensures every stone deserves your trust.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Designers & Manufacturers Focused Support</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Whether you need one-off unique stones or long-term supply relationships, we'll discuss tailored sourcing paths.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <div class="mt-4 p-4">
                    <p class="text-lg text-gray-700 italic">Whether you're looking for a trusted sourcing partner or a unique piece for your next jewellery collection, we're here to collaborate and support your brand's growth.</p>
                </div>
                <!-- Why Visit -->
                <section class="mb-12 mt-6">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at JMA Hong Kong?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Meet Our Diamond Specialists</h3>
                                    <p class="text-gray-700">Meet our founders and specialists in person to discuss your sourcing needs and get professional insights personalized to your market.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Experience Quality Firsthand</h3>
                                    <p class="text-gray-700">Photographs and online catalogs can't capture the true brilliance of a diamond. At our booth, you'll be able to examine cut, clarity, and sparkle up close.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Long-Term Relationships</h3>
                                    <p class="text-gray-700">We're not just exhibitors; we're partners. With decades of industry experience, we focus on creating sustainable, long-term collaborations with our clients worldwide.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let's Connect in Hong Kong</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> November 27–30, 2025</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> 1DA29 | Hong Kong Convention and Exhibition Centre (HKCEC)</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    2: {
        id: 2,
        title: "JGTD Dubai - The International B2B Sourcing Event",
        publishTitle: "Arjiv Exports at JGTD Dubai",
        image: jgtddubai,
        alt: "JGTD Dubai",
        subtitle: "Join us at Booth SH15 to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "jgtd-dubai",
        metaDescription: "At Arjiv Exports, we see JGTD (Jewellery, Gem & Technology) as a powerful new platform where jewellery, gemstones, and tech innovations converge.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">November 11–13, 2025</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">Dubai Exhibition Centre</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth Number: SH15
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4">At Arjiv Exports, we see <span class="font-semibold text-black-800">JGTD</span> (Jewellery, Gem & Technology) as a powerful new platform where jewellery, gemstones, and tech innovations converge. This B2B sourcing event in Dubai is designed to bring global exhibitors and trade buyers together, all within reach from major markets around the world.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">We’re excited to showcase our diamond expertise in <span class="font-semibold text-black-800">natural fancy shape diamonds, precision-cut layouts, and ethically sourced stones</span> crafted with passion, precision, and trust.</p>

                        <p class="text-lg text-justify leading-relaxed mb-6">Whether you are a <span class="font-semibold text-black-800">trade professional, luxury buyer, diamond buyer, or jewelry manufacturer,</span> stop by at JGTD and experience our craftsmanship up close.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About JGTD in Dubai</h2>
                <p class="mb-6 text-justify"><span class="font-semibold text-black-800">JGTD - Jewellery, Gem & Technology</span> is a Dubai‐based international B2B sourcing event, combining the worlds of jewellery, gemstones, and technology in one exhibition. It connects global exhibitors with trade buyers from key markets, offers a curated exhibition of finished jewellery, gems, and related technologies, and aims to boost industry collaboration across regions.</p>
            
                <h2 class="text-2xl font-serif mt-8 mb-4">Who We Are</h2>
                <p class="mb-4"><b>Arjiv Exports</b> is an <b>RJC Certified Diamond Manufacturer</b> known for:</p>
                <ul class="list-none mb-6">
                    <li class="mb-2">✦ 100% natural, conflict-free rough and polished diamonds</li>
                    <li class="mb-2">✦ Unique and rare diamond shapes, calibrated to precision</li>
                    <li class="mb-2">✦ Tailor-made sourcing for global jewellery brands</li>
                    <li class="mb-2">✦ Guaranteed quality, consistency, and timely global shipping</li>
                    <li class="mb-2">✦ Ethical and traceable supply chain practices</li>
                    <li class="mb-2">Visit <a href="/our-history" class="text-blue-700 hover:underline"><b>our history</b></a> page to learn more about us.</li>
                </ul>

                <!-- What You'll See at Our Booth - Enhanced Version -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At <b>JGTD 2025</b>, we’ll be presenting a refined and diverse range of diamonds, including:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                 <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Exclusive Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">From classic cuts to rare silhouettes, we’ll display a diverse selection of shapes crafted with precision and flair.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Brilliant Polished Melee Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Ideal for pavé, halos, and accent detailing, consistent, high-quality small stones.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Tailored Solutions for Brands & Designers</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Tell us what you’re creating — we’ll help you find the perfect stones.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Matched Diamond Layouts</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Sets of diamonds sized and quality–matched for jewellery manufacturers, ready for seamless incorporation into high-end designs.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Our commitment to traceability and responsible sourcing ensures every stone deserves your trust.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Designers & Manufacturers Focused Support</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Whether you need one-off unique stones or long-term supply relationships, we’ll discuss tailored sourcing paths.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <div class="mt-4 p-4">
                    <p class="text-lg text-gray-700 italic">Whether you're looking for a trusted sourcing partner or a unique piece for your next jewellery collection, we're here to collaborate and support your brand's growth.</p>
                </div>
                <!-- Why Visit -->
                <section class="mb-12 mt-6">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at JGTD, Dubai?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Meet Our Diamond Specialists</h3>
                                    <p class="text-gray-700">Meet our founders and specialists in person to discuss your sourcing needs and get professional insights personalized to your market.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Experience Quality Firsthand</h3>
                                    <p class="text-gray-700">Photographs and online catalogs can’t capture the true brilliance of a diamond. At our booth, you’ll be able to examine cut, clarity, and sparkle up close..</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Long-Term Relationships</h3>
                                    <p class="text-gray-700">We’re not just exhibitors; we’re partners. With decades of industry experience, we focus on creating sustainable, long-term collaborations with our clients worldwide.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let’s Connect in Dubai</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> November 11–13, 2025</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> SH15 | Dubai Exhibition Centre</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    3: {
        id: 3,
        title: "GemGenève – International Gem & Jewellery Show 2025",
        publishTitle: "Arjiv Exports at Gem Geneve",
        image: news1,
        alt: "Geneva International Gem & Jewellery Show 2025",
        subtitle: "Join us at Booth C04 to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "geneva-international-gem-and-jewellery-show",
        metaDescription: "Arjiv Exports at Geneva International Gem & Jewellery. Whether you are a jewellery manufacturer, designer, diamond buyer, or wholesaler, we have something for you.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">May 8–11, 2025</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">Palexpo, Geneva, Switzerland</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth Number: C04
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4">We're thrilled to announce that <span class="font-semibold text-black-800">Arjiv Exports</span> will be exhibiting at the prestigious <span class="font-semibold text-black-800">GemGenève – Geneva International Gem & Jewellery Show 2025</span>. As a trusted name in the diamond industry since 1985, we invite you to visit us at <span class="font-semibold text-black-800">Booth C04</span> to explore our exquisite range of <span class="font-semibold text-black-800">natural, ethically sourced rough and polished diamonds</span>.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">Whether you are a <span class="font-semibold text-black-800">jewellery manufacturer</span>, <span class="font-semibold text-black-800">designer</span>, <span class="font-semibold text-black-800">diamond buyer</span>, or <span class="font-semibold text-black-800">wholesaler</span>, this is a great opportunity to experience our craftsmanship, sourcing transparency, and commitment to ethical trade.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About GemGenève</h2>
                <p class="mb-6 text-justify"><a href="https://gemgeneve.com/" target="_blank" class="text-blue-700 hover:underline"><b>GemGenève</b></a> is one of the world's leading exhibitions for diamonds, colored stones, fine jewellery, antique pieces, and emerging designers. It brings together global professionals, collectors, and buyers from over 80 countries.</p>
            
                <h2 class="text-2xl font-serif mt-8 mb-4">Who We Are</h2>
                <p class="mb-4"><b>Arjiv Exports</b> is an <b>RJC Certified Diamond Manufacturer</b> known for:</p>
                <ul class="list-none mb-6">
                    <li class="mb-2">✦ 100% natural, conflict-free rough and polished diamonds</li>
                    <li class="mb-2">✦ Unique and rare diamond shapes, calibrated to precision</li>
                    <li class="mb-2">✦ Tailor-made sourcing for global jewellery brands</li>
                    <li class="mb-2">✦ Guaranteed quality, consistency, and timely global shipping</li>
                    <li class="mb-2">✦ Ethical and traceable supply chain practices</li>
                    <li class="mb-2">Visit <a href="/our-history" class="text-blue-700 hover:underline"><b>our history</b></a> page to learn more about us.</li>
                </ul>

                <h2 class="text-2xl font-serif mt-12 mb-4">What You'll See at Our Booth</h2>
                <p class="mb-4">At <b>GemGenève 2025</b>, we'll be showcasing:</p>
                <ul class="list-none mb-6 pl-4">
                    <li class="mb-2 list-disc"><b>Natural Fancy Shape Diamonds</b></li>
                    <li class="mb-4">Unique silhouettes crafted to inspire creativity and design versatility.</li>
                    <li class="mb-2 list-disc"><b>Custom-Cut Diamond Layouts</b></li>
                    <li class="mb-4">Perfectly matched sets tailored for high-end jewellery collections.</li>
                    <li class="mb-2 list-disc"><b>Polished Melee Diamonds</b></li>
                    <li class="mb-4">Precision-cut small diamonds ideal for adding brilliance to your designs.</li>
                    <li class="mb-2 list-disc"><b>Ethically Sourced Diamonds in a Variety of Cuts and Sizes</b></li>
                    <li class="mb-4">From classic rounds to specialty shapes — responsibly sourced and ready for your next masterpiece.</li>
                    <li class="mb-2 list-disc"><b>Designer-Focused Custom Diamond Solutions</b></li>
                    <li class="mb-2">Collaborative sourcing tailored to the specific needs of jewellery designers and manufacturers.</li>
                </ul>
                    
                <div class="mt-4 p-4">
                    <p class="text-lg text-gray-700 italic">Whether you're looking for a trusted sourcing partner or a unique piece for your next jewellery collection, we're here to collaborate and support your brand's growth.</p>
                </div>
                <!-- Why Visit -->
                <section class="mb-12 mt-6">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at GemGenève?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Meet Our Leaders and Diamond Experts</h3>
                                    <p class="text-gray-700">Discuss your sourcing needs directly with our experienced team.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Hands-On Viewing Experience</h3>
                                    <p class="text-gray-700">Explore a curated selection of our finest inventory in person.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Long-Term Sourcing Relationships</h3>
                                    <p class="text-gray-700">We're here to connect, collaborate, and grow with like-minded professionals. Let's explore how Arjiv Exports can become your trusted diamond partner.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let's Connect in GemGenève</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> May 8–11, 2025</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> C04 | Palexpo, Geneva, Switzerland</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    4: {
        id: 4,
        title: "JCK Las Vegas 2025 - World's Largest and Most Trusted Jewelry Industry Trade Event",
        publishTitle: "Arjiv Exports at JCK Las Vegas",
        image: news2,
        alt: "JCK Las Vegas 2025",
        subtitle: "Join us at Booth 4065 to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "jck-las-vegas",
        metaDescription: "Arjiv Exports at JCK Las Vegas 2025 — Whether you're a diamond buyer, jewelry manufacturer, designer, or trader, visit Booth 4065 to explore our ethically sourced diamonds.",
         content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">June 6–9, 2025</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">The Venetian Expo, Las Vegas, NV</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth Number: 4065
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4">We're excited to announce that <b>Arjiv Exports</b> will exhibit at <b>JCK Las Vegas 2025</b>, the largest and most influential jewelry trade event in North America. Our team is excited to meet you with our exquisite collection of <b>natural, ethically sourced diamonds</b> and discover why we've been a trusted partner for global jewelry professionals since 1985.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">Whether you are a <b>diamond buyer</b>, <b>jewelry manufacturer</b>, <b>designer</b>, or <b>trader</b>, stop by Booth 4065 and experience our craftsmanship up close.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About JCK Las Vegas Show</h2>
                <p class="mb-6 text-justify"><a href="https://lasvegas.jckonline.com/" target="_blank" class="text-blue-700 hover:underline"><b>JCK Las Vegas</b></a> is a premier global gathering for the jewelry industry — uniting retailers, designers, manufacturers, and buyers from over 100 countries. The event offers unmatched opportunities for sourcing, networking, and trend discovery.</p>
            
                <!-- About Arjiv Exports -->
                <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mt-12">
                    <div class="flex items-start">
                        <div class="mr-4 flex-shrink-0">
                            <img src="${logo}" alt="Logo" class="w-12 invert" />
                        </div>
                        <div>
                            <h2 class="text-2xl font-serif mb-4 text-gray-900">About Arjiv Exports</h2>
                            <p class="mb-4 text-gray-700">With decades of experience and a reputation for ethical manufacturing, <b class="text-gray-900">Arjiv Exports</b> offers:</p>
                            <ul class="space-y-3 mb-6">
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">100% natural, conflict-free diamonds</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Rare and fancy shape diamonds crafted with precision</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Custom sourcing solutions for jewelry brands and manufacturers</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Reliable, global shipping backed by strong QC standards</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">RJC Certified processes that prioritize transparency and traceability</span>
                                </li>
                            </ul>
                            <a href="/our-history" target="_blank" class="inline-flex items-center text-gray-900 hover:text-black font-medium underline">
                                Learn more about our history
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- What You'll See at Our Booth - Enhanced Version -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
                    <p class="mb-8 text-gray-700 max-w-2xl">At <b class="text-gray-900">JCK Las Vegas 2025</b>, discover our curated diamond collection featuring:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                 <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Inspiring designs crafted to elevate modern jewelry collections with unique geometries.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Perfect Matched</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Curated sets designed for perfect symmetry, optimal sparkle, and design harmony.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Brilliant Melee</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">High-precision small diamonds to add depth, brilliance and fire to any creation.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Responsibly sourced diamonds in all shapes and sizes from trusted suppliers.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Tailored Solutions</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Custom sourcing for designers & manufacturers with exact specifications.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Quality Assurance</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Every diamond meets our rigorous standards for cut, clarity and color.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <div class="mt-4 p-4">
                    <p class="text-justify text-lg text-stone-700 italic">Whether you're looking for a trusted sourcing partner or unique diamonds for your next jewelry collection, we're here to collaborate and support your brand's growth.</p>
                </div>
                <!-- Why Visit -->
                <section class="mb-12 mt-6">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at JCK?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Meet Our Diamond Specialists</h3>
                                    <p class="text-stone-700">Learn more about our process, materials, and how we support international jewelry brands.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Explore Our Collection in Person</h3>
                                    <p class="text-stone-700">See, touch, and evaluate our diamonds under perfect lighting and expert guidance.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Forge Meaningful Partnerships</h3>
                                    <p class="text-stone-700">Let's connect and build sourcing relationships based on trust, quality, and shared values.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let's Connect in Las Vegas</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> June 6–9, 2025</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> 4065 | The Venetian Expo, Las Vegas</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    5: {
        id: 5,
        title: "Jewellery & Gem World Hong Kong 2025 - Asia’s No. 1 fine Jewellery Event",
        publishTitle: "Arjiv Exports at Jewellery & Gem World Hong Kong",
        image: news3,
        alt: "Jewellery & Gem World Hong Kong 2025",
        subtitle: "Join us at Booth 9-9D27  to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "jewellery-and-gem-world-hong-kong",
        metaDescription: "Arjiv Exports is proud to be exhibiting at Jewellery & Gem WORLD Hong Kong 2025, Asia’s No.1 fine jewellery sourcing event in the global jewellery calendar.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">September 15 – 19, 2025</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">: AsiaWorld-Expo, Hong Kong</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth Number : 9-9D27
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4"><b>Arjiv Exports</b> is proud to be exhibiting at <a href="https://jga.exhibitions.jewellerynet.com/" target="_blank" class="text-blue-700 hover:underline"><b>Jewellery & Gem WORLD Hong Kong 2025</b></a>, Asia's No.1 fine jewellery sourcing event in the global jewellery calendar. Join us at JGW to explore our premium collection of <b>natural, ethically sourced diamonds</b> and connect with our expert team.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">We look forward to welcoming <b>diamond buyers</b>, <b>jewellery manufacturers</b>, <b>designers</b>, <b>wholesalers</b>, and <b>traders</b> from across Asia and beyond. If you're looking for rare fancy shapes, custom-matched layouts, or a reliable sourcing partner, visit our booth and experience the difference and craftsmanship of Arjiv Exports.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About Jewellery & Gem WORLD Hong Kong</h2>
                <p class="mb-6 text-justify"><b>Jewellery & Gem WORLD Hong Kong</b> stands as Asia's premier B2B fine jewellery sourcing event, drawing over 1,300 exhibitors from more than 30 countries and regions. Scheduled from September 15 to 19, 2025, at the AsiaWorld-Expo, JGW offers a dynamic platform for trade buyers to explore a vast array of products, including diamonds, coloured gemstones, pearls, finished jewellery, and industry-related technologies.</p>
                
                <!-- About Arjiv Exports -->
                <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mt-12">
                    <div class="flex items-start">
                        <div class="mr-4 flex-shrink-0">
                            <img src="${logo}" alt="Logo" class="w-12 invert" />
                        </div>
                        <div>
                            <h2 class="text-2xl font-serif mb-4 text-gray-900">About Arjiv Exports</h2>
                            <p class="mb-4 text-gray-700">With decades of experience and a reputation for ethical manufacturing, <b class="text-gray-900">Arjiv Exports</b> offers:</p>
                            <ul class="space-y-3 mb-6">
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">100% natural, conflict-free diamonds</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Melee diamonds for intricate designs</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Designer-focused custom sourcing</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Worldwide shipping and reliable turnaround</span>
                                </li>
                            </ul>
                            <a href="/our-history" target="_blank" class="inline-flex items-center text-gray-900 hover:text-black font-medium underline">
                                Learn more about our history
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- What You'll See at Our Booth - Enhanced Version -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At <b>Jewellery & Gem WORLD Hong Kong</b>, we’ll be showcasing a curated selection of our finest, including:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                 <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Innovative cuts that add character and uniqueness to fine jewellery pieces.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Precision-Cut Melee Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Bright, uniform melee stones are ideal for detailed craftsmanship.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Tailored Solutions for Brands & Designers</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Tell us what you’re creating — we’ll help you find the perfect stones.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Cut Diamond</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Perfectly matched diamonds ready to be set into necklaces, earrings, and bracelets.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Responsible sourcing with a wide variety of shapes, sizes, and clarity grades.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Quality Assurance</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Every diamond meets our rigorous standards for cut, clarity and color.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <!-- Why Visit -->
                <section class="mb-12 mt-12">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at JGW?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">One-on-One Consultations with Our Experts</h3>
                                    <p class="text-gray-700">Discuss your sourcing needs with professionals who understand your market and vision.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Explore Our Inventory in Person</h3>
                                    <p class="text-gray-700">Experience the quality of our diamonds with your own eyes — and hands.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Start Long-Term Partnerships</h3>
                                    <p class="text-gray-700">We’re here to build relationships that go beyond a single transaction.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <p class="text-gray-700">We look forward to welcoming you to Jewellery & Gem WORLD Hong Kong 2025!</p>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let’s Connect at the Jewellery & Gem WORLD Hong Kong</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> September 15 – 19, 2025</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> 9-9D27 | AsiaWorld-Expo, Hong Kong</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    6: {
        id: 6,
        title: "Arjiv Exports at IIJS Bharat - Signature 2026",
        publishTitle: "Arjiv Exports at India’s Premier Jewellery Trade Show",
        image: news4,
        alt: "IIJS Bharat - Signature 2026",
        subtitle: "Join us to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "iijs-bharat-signature-2026",
        metaDescription: "Arjiv Exports is excited to announce that Arjiv Exports will be exhibiting at IIJS Bharat - Signature 2026 at the Jio World Convention Centre (JWCC), Mumbai.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">08th – 11th January, 2026</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">Jio World Convention Centre, Mumbai</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Hall : JIO-M.24C
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4">
                            We’re excited to announce that <b>Arjiv Exports</b> will be exhibiting at
                            <a href="https://gjepc.org/iijs-signature/show-details.php" target="_blank" class="text-blue-700 hover:underline">
                                <b>IIJS Bharat – Signature 2026</b>
                            </a>
                            at the <b>Jio World Convention Centre (JWCC), Mumbai.</b> As one of India’s leading RJC-certified diamond manufacturers, we’re proud to showcase our signature collection of <b>fancy shape diamonds, custom-cut layouts, and ethically sourced stones</b> to a global and domestic audience.
                        </p>

                        <p class="text-lg text-justify leading-relaxed mb-6">
                            If you’re a <b>jewellery manufacturer, diamond buyer, retailer, or wholesaler,</b>
                            this is your opportunity to explore top-tier diamonds tailored to your design and sourcing needs.
                        </p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">
                    About IIJS Bharat – Signature
                </h2>

                <p class="mb-6 text-justify">
                    <b>IIJS Bharat – Signature</b> is one of the most prestigious B2B jewellery trade events in India and Asia,
                    attracting top manufacturers, retailers, and designers from across the world.
                    With its focus on premium sourcing, innovation, and business growth, it’s a key platform for serious trade professionals.
                </p>

                <ul class="space-y-3 mb-6 ml-4">
                    <li class="flex items-start"><span class="text-black mr-2">✦</span><span class="text-gray-700">Signature Edition Jewellery Trade Show</span></li>
                    <li class="flex items-start"><span class="text-black mr-2">✦</span><span class="text-gray-700">Premium Exhibitors</span></li>
                    <li class="flex items-start"><span class="text-black mr-2">✦</span><span class="text-gray-700">High-Value Trade Buyers</span></li>
                </ul>

                <!-- About Arjiv Exports -->
                <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mt-12">
                    <div class="flex items-start">
                        <div class="mr-4 flex-shrink-0">
                            <img src="${logo}" alt="Logo" class="w-12 invert" />
                        </div>
                        <div>
                            <h2 class="text-2xl font-serif mb-4 text-gray-900">About Arjiv Exports</h2>
                            <p class="mb-4 text-gray-700">Established in 1985, Arjiv Exports is a trusted name in the diamond industry, known for ethical manufacturing, innovative cuts, and long-standing partnerships with global jewellery brands.</p>
                            <p class="mb-4 text-gray-700">We specialize in:</p>
                            <ul class="space-y-3 mb-6">
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">100% natural, conflict-free diamonds</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Precision-cut fancy shapes and layouts</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Melee diamonds for detailed jewellery work</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Custom sourcing for designers and manufacturers</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Global logistics and timely delivery</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Transparent, RJC-certified processes</span>
                                </li>
                            </ul>
                            <span class="text-gray-700">Visit</span>
                            <a href="/our-history" target="_blank" class="text-blue-700 hover:underline">
                                <b>our history</b>
                            </a>
                            <span class="text-gray-700">page to learn more about us.</span>
                        </div>
                    </div>
                </div>

                <!-- What You'll See at Our Booth - Enhanced Version -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You’ll Discover at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At <b>IIJS 2026,</b> we’ll be presenting an exclusive collection including:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                 <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">From classic to creative shapes, ideal for elevating any jewellery design.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">High-Quality Melee Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Ideal for pavé, halo, and accent settings — bright, uniform, and ready to set.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Designer-Centric Sourcing Support</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Personalized solutions for brands and artisans creating bespoke pieces.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Matched Diamond Layouts</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Meticulously sorted for symmetry and brilliance — ready for seamless setting.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Responsibly Sourced Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Every stone backed by traceability and quality assurance.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Quality Assurance</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Every diamond meets our rigorous standards for cut, clarity and color.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <!-- Why Visit -->
                <section class="mb-12 mt-12">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at IIJS?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Connect with Our Diamond Experts</h3>
                                    <p class="text-gray-700">Share your requirements and let’s discuss how we can support your brand’s sourcing goals.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">See the Quality in Person</h3>
                                    <p class="text-gray-700">Examine our diamonds firsthand — clarity, cut, and brilliance that stand out.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Sustainable Business Relationships</h3>
                                    <p class="text-gray-700">We’re not just suppliers — we’re long-term partners dedicated to your success.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">
                        Let’s Connect at IIJS Bharat – Signature 2026
                    </p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> 08th – 11th January, 2026</p>
                    <p class="mb-2">Jio World Convention Centre (JWCC), Mumbai</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" class="bg-white mr-4 hover:bg-[#f5f5f5] py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=918758248992&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" class="bg-white hover:bg-[#f5f5f5] py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91 87582 48992
                        </a>
                    </p>
                </div>
                <p class="text-gray-700 mt-6">We look forward to welcoming you to IIJS Bharat – Signature 2026!</p>
            </div>
        </div>
        `
    },
    7: {
        id: 7,
        title: "Arjiv Exports at VICENZAORO 2026",
        publishTitle: "Meet Arjiv Exports at Italy's Premier Jewellery Show - VICENZAORO 2026",
        image: news5,
        alt: "India International Jewellery Show 2026",
        subtitle: "Join us at Hall 3.1-266 to explore our exquisite range of natural, ethically sourced diamonds",
        slug: "vicenzaoro",
        metaDescription: "Arjiv Exports is excited to announce that Arjiv Exports will be exhibiting at VICENZAORO 2026 - Vicenza, Italy",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">January 16 – January 20, 2026</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">: Vicenza, Italy</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Hall 3.1-266
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4">Arjiv Exports is proud to exhibit at <b>VICENZAORO</b>, one of Europe's most influential jewellery exhibitions. Held in <b>Vicenza, Italy,</b> this global trade show brings together the world's most renowned jewellery manufacturers, designers, and diamond suppliers—and we are thrilled to be part of it once again.</p>
                        <p class="text-lg text-justify leading-relaxed mb-6">Since 1985, <b>Arjiv Exports</b> has been a trusted partner for international jewellery houses, offering ethically sourced natural diamonds in custom shapes and precision layouts.</p>
                        <p class="text-lg text-justify leading-relaxed mb-6">Whether you're a <b>high-end jewellery designer</b>, a <b>wholesale diamond buyer,</b> or a <b>jewellery brand looking for consistent supply,</b> visit our booth to explore our exquisite diamond selections and build a reliable sourcing relationship.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About VICENZAORO 2026</h2>
                <p class="mb-6 text-justify">For 70+ years, Vicenzaoro has been the go-to place for everyone in the jewelry, goldsmithing, and watch business. It's all about Italian quality, luxury, and innovation. It attracts thousands of professionals from 145+ countries, making it the perfect platform to connect with global buyers and innovators.</p>

                <ul class="space-y-3 mb-6 ml-4">
                    <li class="flex items-start">
                        <span class="text-black mr-2">✦</span><span class="text-gray-700">40+ group and themed pavilions</span>
                    </li>
                    <li class="flex items-start">
                        <span class="text-black mr-2">✦</span><span class="text-gray-700">1300+ Exhibitors</span>
                    </li>
                    <li class="flex items-start">
                        <span class="text-black mr-2">✦</span><span class="text-gray-700">145 countries</span>
                    </li>
                    <li class="flex items-start">
                        <span class="text-black mr-2">✦</span><span class="text-gray-700">70 Years of history</span>
                    </li>
                </ul>
                
                <!-- About Arjiv Exports -->
                <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mt-12">
                    <div class="flex items-start">
                        <div class="mr-4 flex-shrink-0">
                            <img src="${logo}" alt="Logo" class="w-12 invert" />
                        </div>
                        <div>
                            <h2 class="text-2xl font-serif mb-4 text-gray-900">About Arjiv Exports</h2>
                            <p class="mb-4 text-gray-700">Established in 1985, Arjiv Exports is a trusted name in the diamond industry, known for ethical manufacturing, innovative cuts, and long-standing partnerships with global jewellery brands.</p>
                            <p class="mb-4 text-gray-700">We specialize in:</p>
                            <ul class="space-y-3 mb-6">
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">100% natural, conflict-free diamonds</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Precision-cut fancy shapes and layouts</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Melee diamonds for detailed jewellery work</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Custom sourcing for designers and manufacturers</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Global logistics and timely delivery</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Transparent, RJC-certified processes</span>
                                </li>
                            </ul>
                            <span class="text-gray-700">Visit</span>
                            <a href="/our-history" target="_blank" class="text-blue-700 hover:underline">
                                <b>our history</b>
                            </a>
                            <span class="text-gray-700">page to learn more about us.</span>
                        </div>
                    </div>
                </div>

                <!-- What You'll See at Our Booth - Enhanced Version -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll Discover at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At <b>VICENZAORO 2026,</b> we will showcase a carefully curated selection of:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                 <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Natural Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Perfect for bold, statement-making designs.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Matched Diamond Layouts</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Custom sets tailored for fine jewellery manufacturers.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Matched Diamond Layouts</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Meticulously sorted for symmetry and brilliance — ready for seamless setting.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${consistency}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Designer-Centric Sourcing Support</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">We assist designers and brands in finding rare cuts and consistent quality fast.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <!-- Why Visit -->
                <section class="mb-12 mt-12">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Us at VICENZAORO 2026?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Engage with Our Diamond Specialists & Founders</h3>
                                    <p class="text-gray-700">Speak directly with the people behind the process and vision.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Hands-On Experience</h3>
                                    <p class="text-gray-700">Examine the craftsmanship, cut precision, and light performance of our diamonds.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Long-Term Partnerships</h3>
                                    <p class="text-gray-700">We're committed to ethical manufacturing and transparent relationships, not just transactions.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <p class="text-gray-700">We'd love to meet you at the show!</p>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let's Connect at VICENZAORO 2026</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> January 16 – January 20, 2026</p>
                    <p class="mb-2">Hall 3.1 266, Vicenza - Italy</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=++918758248992&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91 87582 48992
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    8: {
        id: 8,
        title: "Hong Kong International Diamond, Gem & Pearl Show 2026 - Premier Gemstone Sourcing Event",
        publishTitle: "Arjiv Exports at Hong Kong International Diamond, Gem & Pearl Show",
        image: hktdc,
        alt: "Hong Kong International Diamond, Gem & Pearl Show 2026",
        subtitle: "Visit us to discover our exceptional collection of natural, ethically sourced diamonds and explore new sourcing opportunities",
        slug: "hong-kong-international-diamond-gem-and-pearl-show",
        metaDescription: "Arjiv Exports is excited to exhibit at the Hong Kong International Diamond, Gem & Pearl Show 2026, one of Asia's leading gemstone and diamond sourcing events.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">March 2 – 6, 2026</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">AsiaWorld-Expo</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth No. 5-A17
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4"><b>Arjiv Exports</b> is excited to be exhibiting at the <b>Hong Kong International Diamond, Gem & Pearl Show 2026</b>, one of Asia's premier trade events for loose diamonds, gemstones, and pearls. Join us at this prestigious show to explore our premium collection of <b>natural, ethically sourced diamonds</b> and connect with our expert team.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">We look forward to welcoming <b>diamond buyers</b>, <b>jewellery manufacturers</b>, <b>wholesalers</b>, <b>retailers</b>, <b>designers</b>, and <b>traders</b> from across Asia and around the world. Whether you're seeking rare fancy shapes, precision-cut melee diamonds, or custom-matched layouts, visit our booth to experience the quality and craftsmanship of Arjiv Exports.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About Hong Kong International Diamond, Gem & Pearl Show</h2>
                <p class="mb-6 text-justify">The <b>Hong Kong International Diamond, Gem & Pearl Show</b> is organized by the Hong Kong Trade Development Council (HKTDC) and stands as one of the world's largest trade fairs for loose diamonds, gemstones, and pearls. Running from March 2 to 6, 2026, at the AsiaWorld-Expo, this B2B event brings together exhibitors and buyers from around the globe, offering an unparalleled platform to source high-quality diamonds, colored gemstones, pearls, and related industry products.</p>
                
                <!-- About Arjiv Exports -->
                <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mt-12">
                    <div class="flex items-start">
                        <div class="mr-4 flex-shrink-0">
                            <img src="${logo}" alt="Logo" class="w-12 invert" />
                        </div>
                        <div>
                            <h2 class="text-2xl font-serif mb-4 text-gray-900">About Arjiv Exports</h2>
                            <p class="mb-4 text-gray-700">With decades of experience and a reputation for ethical manufacturing, <b class="text-gray-900">Arjiv Exports</b> offers:</p>
                            <ul class="space-y-3 mb-6">
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">100% natural, conflict-free diamonds</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Melee diamonds for intricate designs</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Designer-focused custom sourcing</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Worldwide shipping and reliable turnaround</span>
                                </li>
                            </ul>
                            <a href="/our-history" target="_blank" class="inline-flex items-center text-gray-900 hover:text-black font-medium underline">
                                Learn more about our history
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- What You'll See at Our Booth -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At the <b>Hong Kong International Diamond, Gem & Pearl Show</b>, we'll be showcasing a curated selection of our finest diamonds, including:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Innovative cuts including marquise, pear, oval, and cushion that add character to fine jewellery pieces.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Precision-Cut Melee Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Bright, uniform melee stones ranging from 0.80mm to 4.00mm, ideal for detailed craftsmanship.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Tailored Solutions for Brands & Designers</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Tell us what you're creating — we'll help you source the perfect stones for your vision.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom-Matched Layouts</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Perfectly matched diamonds ready to be set into necklaces, earrings, bracelets, and statement pieces.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Responsible sourcing with a wide variety of shapes, sizes, and clarity grades for every design need.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Quality Assurance</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Every diamond meets our rigorous standards for cut, clarity, color, and ethical sourcing.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <!-- Why Visit -->
                <section class="mb-12 mt-12">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at the Show?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Personal Consultations with Diamond Experts</h3>
                                    <p class="text-gray-700">Discuss your sourcing needs with professionals who understand the Asian market and global trends.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">View Our Entire Collection in Person</h3>
                                    <p class="text-gray-700">Experience the brilliance and quality of our diamonds firsthand — see, touch, and evaluate before you buy.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Strategic Partnerships</h3>
                                    <p class="text-gray-700">We're committed to long-term relationships that support your business growth and success.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <p class="text-gray-700">We look forward to welcoming you to the Hong Kong International Diamond, Gem & Pearl Show 2026!</p>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let's Connect at the Hong Kong International Diamond, Gem & Pearl Show</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> March 2 – 6, 2026</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> 5-A17 | AsiaWorld-Expo</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    },
    9: {
        id: 9,
        title: "Miami Beach Antique Show 2026 - Premier Antiques & Fine Art Event",
        publishTitle: "Arjiv Exports at Miami Beach Antique Show",
        image: miami,
        alt: "Miami Beach Antique Show 2026",
        subtitle: "Visit us at the Miami Beach Convention Center to discover our exceptional collection of natural, ethically sourced diamonds",
        slug: "miami-beach-antique-show",
        metaDescription: "Arjiv Exports is excited to exhibit at the Miami Beach Antique Show 2026, one of America's most prestigious fine art and antiques events.",
        content: `
        <div class="news-article">
            <!-- Main Content -->
            <div class="content-wrapper max-w-3xl mx-auto px-4">
                <!-- Introduction -->
                <div class="event-card bg-white rounded-xl shadow-md p-8 mb-12 mt-4 border-l-4 border-[#78350F]">
                    <div class="flex flex-col md:flex-row md:items-center justify-between mb-6">
                        <div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Event Date: <span class="font-normal ml-2">March 26 – 30, 2026</span>
                            </div>
                            <div class="font-bold text-gray-700 mb-1 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Venue: <span class="font-normal ml-2">Miami Beach Convention Center, USA</span>
                            </div>
                        </div>
                        <div class="mt-4 md:mt-0">
                            <div class="inline-flex items-center px-4 py-2 bg-[#212121] text-white rounded-lg font-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                Booth No. 1639
                            </div>
                        </div>
                    </div>

                    <div class="prose max-w-none">
                        <p class="text-lg text-justify leading-relaxed mb-4"><b>Arjiv Exports</b> is excited to exhibit at the <b>Miami Beach Antique Show 2026</b>, one of America's most prestigious fine art and antiques events. Join us at this renowned show to explore our premium collection of <b>natural, ethically sourced diamonds</b> and connect with our expert team.</p>
                        
                        <p class="text-lg text-justify leading-relaxed mb-6">We look forward to welcoming <b>antique jewellery dealers</b>, <b>collectors</b>, <b>estate jewellery specialists</b>, <b>designers</b>, and <b>discerning buyers</b> from across the Americas and beyond. Whether you're seeking rare fancy shapes, period-appropriate stones, or custom-matched layouts, visit our booth to experience the quality and craftsmanship of Arjiv Exports.</p>
                    </div>
                </div>

                <h2 class="text-3xl font-serif tracking-wide mt-8 mb-4">About Miami Beach Antique Show</h2>
                <p class="mb-6 text-justify">The <b>Miami Beach Antique Show</b> is one of the longest-running and most respected antiques shows in the United States. Held annually at the Miami Beach Convention Center, this prestigious event brings together leading dealers, collectors, and enthusiasts from around the world. From March 26 to 30, 2026, visitors will discover an exceptional selection of fine art, antique jewellery, furniture, decorative arts, and rare collectibles spanning multiple centuries and styles.</p>
                
                <!-- About Arjiv Exports -->
                <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mt-12">
                    <div class="flex items-start">
                        <div class="mr-4 flex-shrink-0">
                            <img src="${logo}" alt="Logo" class="w-12 invert" />
                        </div>
                        <div>
                            <h2 class="text-2xl font-serif mb-4 text-gray-900">About Arjiv Exports</h2>
                            <p class="mb-4 text-gray-700">With decades of experience and a reputation for ethical manufacturing, <b class="text-gray-900">Arjiv Exports</b> offers:</p>
                            <ul class="space-y-3 mb-6">
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">100% natural, conflict-free diamonds</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Melee diamonds for intricate designs</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Period-appropriate stones for restoration projects</span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-black mr-2">✦</span>
                                    <span class="text-gray-700">Worldwide shipping and reliable turnaround</span>
                                </li>
                            </ul>
                            <a href="/our-history" target="_blank" class="inline-flex items-center text-gray-900 hover:text-black font-medium underline">
                                Learn more about our history
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- What You'll See at Our Booth -->
                <div class="mt-12">
                    <h2 class="text-3xl font-serif mb-8 text-gray-900 border-b border-gray-200 pb-4">What You'll See at Our Booth</h2>
                    <p class="mb-8 text-justify text-gray-700 max-w-2xl">At the <b>Miami Beach Antique Show</b>, we'll be showcasing a curated selection of our finest diamonds, including:</p>
                    
                    <div class="grid md:grid-cols-2 gap-6">
                        <!-- Column 1 -->
                        <div class="space-y-6">
                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${fancyShapeIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Fancy Shape Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Old mine cuts, rose cuts, and other vintage-inspired shapes perfect for restoration and period pieces.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${layoutsIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Precision-Cut Melee Diamonds</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Bright, uniform melee stones ideal for antique jewellery restoration and detailed craftsmanship.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${customIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Custom Sourcing for Collectors & Dealers</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Tell us about your restoration project — we'll help you find the perfect period-appropriate stones.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="space-y-6">

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${perfectIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Matched Diamond Parcels</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Perfectly matched diamonds ready for necklaces, brooches, earrings, and estate-style pieces.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${ethicalIcon}" alt="Logo" class="w-12" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Ethically Sourced</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Responsible sourcing with a wide variety of shapes, sizes, and clarity grades for every era.</p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="p-2 mr-4 flex-shrink-0">
                                    <img src="${gradingIcon}" alt="Logo" class="w-12 invert" />
                                </div>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-gray-900 uppercase tracking-wider">Quality Assurance</h3>
                                    <p class="text-stone-700 text-sm leading-relaxed">Every diamond meets our rigorous standards for cut, clarity and color.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                <!-- Why Visit -->
                <section class="mb-12 mt-12">
                    <h2 class="text-3xl font-serif font-bold tracking-wide mb-6 text-gray-800 flex items-center">
                        <span class="w-8 h-1 bg-[#212121] block mr-2"></span>
                        Why Visit Arjiv Exports at Miami Beach Antique Show?
                    </h2>
                    
                    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Expert Consultations</h3>
                                    <p class="text-gray-700">Discuss your sourcing and restoration needs with professionals who understand antique and vintage jewellery.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Examine Our Collection in Person</h3>
                                    <p class="text-gray-700">Experience the brilliance and quality of our diamonds with your own eyes — perfect for dealers and collectors.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-6 border-l-4 border-[#212121] hover:bg-black-50 transition-colors border-t border-gray-100">
                            <div class="flex items-start">
                                <div class="flex-shrink-0 mr-4">
                                    <div class="h-10 w-10 rounded-full bg-black-100 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="text-xl font-bold text-gray-800 mb-2">Build Lasting Partnerships</h3>
                                    <p class="text-gray-700">We're here to establish relationships that extend beyond a single transaction — your trusted diamond source.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <p class="text-gray-700">We look forward to welcoming you to the Miami Beach Antique Show 2026!</p>

                <!-- Call to Action -->
                <div class="connect-section mt-8 p-6 bg-gray-50 rounded-lg text-center border border-gray-200">
                    <p class="text-2xl font-serif font-bold mb-4">Let's Connect at Miami Beach Antique Show</p>
                    <p class="mb-4">We'd love to meet you at the show!</p>
                    <p class="mb-2"><span class="font-bold">Date:</span> March 26 – 30, 2026</p>
                    <p class="mb-2"><span class="font-bold">Booth No:</span> 1639 | Miami Beach Convention Center, USA</p>
                    <p class="mb-2 mt-6">
                        <a href="mailto:harshil@arjiv.com" id="email" name="email" class="bg-white mr-4 hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            harshil@arjiv.com
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=+919313807684&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you" target="_blank" id="phone" name="phone" class="bg-white hover:bg-[#f5f5f5] hover:text-gray-800 py-2 px-4 border border-gray-400 rounded shadow inline-block">
                            +91-9313807684
                        </a>
                    </p>
                </div>
            </div>
        </div>
        `
    }
};